import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { NewReleaseComponent } from './new-release/new-release.component';

@Injectable()
export class DeactivateGuardService implements CanDeactivate<NewReleaseComponent>{

  canDeactivate(component: NewReleaseComponent) {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}